import {
  formatGraphQLError,
  formatServerError,
  pageInfo,
  parseData,
} from "../../utils/helper";
import {
  CURRENt_USER_WITH_ROLES_SUCCESS,
  CURRENTUSER_DATA_SUCCESS,
  CLEAR_DATA_SUCCESS,
  EXAMPLE_ACTION,
  FETCH_CONTRIBUTION_PLAN_SUCCESS,
  FETCH_DATA_SUCCESS,
  FETCH_DISTRICT_LOCATION_SUCCESS,
  FETCH_LOCATION_SUCCESS,
  FORGOT_DATA_SUCCESS,
  LOGIN_DATA_SUCCESS,
  REFRESH_TOKEN_DATA_SUCCESS,
  RESET_DATA_SUCCESS,
  FETCH_CONTRIBUTIONBYID_PLAN_SUCCESS,
  FETCH_INSUREEBYID_SUCCESS,
  FETCH_POLICYHOLDERINSUREE_SUCCESS,
  FETCH_POLICYHOLDER_USER_SUCCESS,
  FETCH_MUNICIPALITY_LOCATION_SUCCESS,
  FETCH_ALL_LOCATION_SUCCESS,
  FETCH_ALL_LOCATION_REQUEST,
  FETCH_VILLAGE_LOCATION_SUCCESS,
  CREATE_POLICYHOLDERINSUREECREATE_SUCCESS,
  UPDATE_POLICYHOLDERINSUREEUPDATE_SUCCESS,
  DELETE_POLICYHOLDERINSUREEDELETE_SUCCESS,
  PRINT_INSUREE_SUCCESS,
  CORE_MUTATION_RESP,
  DOCUMENT_FILE_RESP,
  TEMPLATE_FILE_RESP,
  DOCUMENT_DOCUMENTS_RESP,
  UPLOAD_FILE_RESP,
  DELETE_FILE_RESP,
  FETCH_CONTRACT_FAILURE,
  FETCH_CONTRACT_SUCCESS,
  FETCH_CONTRACT_REQUEST,
  FETCH_PAYEMTS_SUCCESS,
  FETCH_PAYEMTSBYID_SUCCESS,
  FETCH_ENDATE_REQUEST,
  FETCH_ENDATE_SUCCESS,
  FETCH_ENDATE_FAILURE,
  FETCH_CREATE_CONTRACT_SUCCESS,
  FETCH_CONTRACT_DETAILS_FAILURE,
  FETCH_CONTRACT_DETAILS_REQUEST,
  FETCH_CONTRACT_DETAILS_SUCCESS,
  FETCH_POLICYHOLDER_INSUREE_REQUEST,
  FETCH_POLICYHOLDER_INSUREE_SUCCESS,
  FETCH_POLICYHOLDER_INSUREE_FAILURE,
  UPDATE_PAYMENT_SUCCESS,
  SUBMIT_CONTRACT_SUCCESS,
  DELETE_CONTRACT_DETAIL_SUCCESS,
  LOGIN_DATA_FAILURE,
  FETCH_USER_VALIDATION_SUCCESS,
  PRINT_POLICYHOLDER_SUCCESS,
  CLEAR_PRINT_INSUREE,
  FETCH_NOTIFICATIONS_FAILURE,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_REQUEST,
  CLEAN_SELECTED_INSUREE,
} from "../actions/types";
import _ from "lodash";

const initialState = {
  signUpResponseData: null,
  fetchingSignUp: false,
  fetchedSignUp: false,
  errorSignUp: null,

  locationResponseData: null,
  fetchingLocation: false,
  fetchedLocation: false,
  errorLocation: null,

  loginResponseData: null,
  loginResponseUserData: null,
  fetchingLogin: false,
  fetchedLogin: false,
  errorLogin: null,

  forgotResponseData: null,
  fetchingForgot: false,
  fetchedForgot: false,
  errorForgot: null,

  resetResponseData: null,
  fetchingReset: false,
  fetchedReset: false,
  errorReset: null,

  currentUserResponseData: null,
  fetchingcurrentUser: false,
  fetchedcurrentUser: false,
  errorcurrentUser: null,

  contributionPlanResponseData: null,
  fetchingcontributionPlan: false,
  fetchedcontributionPlan: false,
  errorcontributionPlan: null,

  contributionPlanByIdResponseData: null,
  fetchingcontributionPlanById: false,
  fetchedcontributionPlanById: true,
  errorcontributionPlanById: null,

  insureeByIdResponseData: null,
  fetchinginsureeById: false,
  fetchedinsureeById: true,
  errorinsureeById: null,

  policyHolderByInsureeResponseData: null,
  policyHolderByInsureeResponseDataPageInfo: { totalCount: 0 },
  fetchingpolicyHolderByInsuree: false,
  fetchedpolicyHolderByInsuree: true,
  errorpolicyHolderByInsuree: null,
  endCursorcursor: null,

  policyholderUserResponseData: null,
  fetchingPolicyholderUser: false,
  fetchedPolicyholderUser: false,
  errorPolicyholderUser: null,

  locationMunicipalityResponseData: null,
  fetchingMunicipalityLocation: false,
  fetchedMunicipalityLocation: false,
  errorMunicipalityLocation: null,

  locationVillageResponseData: null,
  fetchingVillageLocation: false,
  fetchedVillageLocation: false,
  errorVillageLocation: null,

  createPolicyholderInsureeCreate: null,
  fetchingPolicyholderInsureeCreate: false,
  fetchedPolicyholderInsureeCreate: false,
  errorPolicyholderInsureeCreate: null,

  updatePolicyholderInsureeUpdate: null,
  fetchingPolicyholderInsureeUpdate: false,
  fetchedPolicyholderInsureeUpdate: false,
  errorPolicyholderInsureeUpdate: null,

  deletePolicyholderInsureedelete: null,
  fetchingPolicyholderInsureedelete: false,
  fetchedPolicyholderInsureedelete: false,
  errorPolicyholderInsureedelete: null,

  printInsuree: null,
  fetchingPrintInsuree: false,
  fetchedPrintInsuree: false,
  errorPrintInsuree: null,

  paymentData: null,
  paymentDataPageInfo: { totalCount: 0 },
  fetchingpaymentData: false,
  fetchedpaymentData: false,
  errorpaymentData: null,

  paymentDataById: null,
  paymentDataByIdPageInfo: { totalCount: 0 },
  fetchingpaymentDataById: false,
  fetchedpaymentDataById: false,
  errorpaymentDataById: null,

  fetchingMutations: false,
  mutations: null,

  fileData: null,
  documentData: null,
  templateData: null,
  uploadedData: null,
  deletedData: null,

  fetchingContracts: false,
  errorContracts: null,
  fetchedContracts: false,
  contracts: [],
  contractsPageInfo: {},
  contractsTotalCount: 0,

  fetchingDate: false,
  fetchedDate: false,
  endDate: null,
  errorDate: null,

  contractResponseData: null,
  fetchingContract: false,
  fetchedContract: false,
  errorContract: null,

  fetchingContractDetails: false,
  errorContractDetails: null,
  fetchedContractDetails: false,
  contractDetails: [],
  contractDetailsPageInfo: {},
  contractDetailsTotalCount: 0,

  fetchingPickerPolicyHolderInsurees: false,
  errorPickerPolicyHolderInsurees: null,
  fetchedPickerPolicyHolderInsurees: false,
  pickerPolicyHolderInsurees: [],
  pickerPolicyHolderInsureesPageInfo: {},
  pickerPolicyHolderInsureesTotalCount: 0,

  updatePayment: null,
  fetchingUpdatePayment: false,
  fetchedUpdatePayment: false,
  errorUpdatePayment: null,

  submitContract: null,
  fetchingSubmitContract: false,
  fetchedSubmitContract: false,
  errorSubmitContract: null,

  deleteContractDetail: null,
  fetchingdeleteContractDetail: false,
  fetcheddeleteContractDetail: false,
  errordeleteContractDetail: null,

  userValidationDetail: null,
  fetchingUserValidationDetail: false,
  fetchedUserValidationDetail: false,
  errorUserValidationDetail: null,

  printPolicyholder: null,
  fetchingPrintPolicyholder: false,
  fetchedPrintPolicyholder: false,
  errorPrintPolicyholder: null,

  fetchingNotificationList: false,
  fetchedNotificationList: false,
  notificationList: null,
  notificationListTotalCount: null,
  errorNotificationList: null,

  currentUserRoles: null,

  userVerificationSuccess: null,
  userVerificationLoading: false,
  userVerificationError: null,
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case "VERIFY_USER_AND_UPDATE_PASSWORD_SUCCESS":
      return {
        ...state,
        userVerificationSuccess: true,
        userVerificationLoading: false,
        userVerificationError: null,
      };
    case "VERIFY_USER_AND_UPDATE_PASSWORD_FAILURE":
      return {
        ...state,
        userVerificationSuccess: false,
        userVerificationLoading: false,
        userVerificationError: action.payload,
      };
    case CURRENt_USER_WITH_ROLES_SUCCESS:
      return {
        ...state,
        currentUserRoles: action.payload,
      };
    case FETCH_DATA_SUCCESS:
      return {
        ...state,
        signUpResponseData: action.payload?.createPhPortalUser,
        fetchingSignUp: false,
        fetchedSignUp: true,
        errorSignUp: null,
      };
    case CLEAR_DATA_SUCCESS:
      return {
        ...state,
        signUpResponseData: null,

        errorSignUp: null,
      };
    case FETCH_LOCATION_SUCCESS:
      return {
        ...state,
        locationResponseData: parseData(
          action.payload.locationsStrNotAuth || action.payload.data.locationsStr
        ),
        fetchingLocation: false,
        fetchedLocation: true,
        errorLocation: null,
      };
    case LOGIN_DATA_SUCCESS:
      return {
        ...state,
        loginResponseData: action?.payload?.tokenAuth?.token,
        loginResponseUserData: action?.payload?.tokenAuth,
        fetchingLogin: false,
        fetchedLogin: true,
        errorLogin: null,
      };
    case LOGIN_DATA_FAILURE:
      return {
        ...state,
        fetchingLogin: false,
        fetchedLogin: true,
        errorLogin: action?.payload,
      };
    case FETCH_DISTRICT_LOCATION_SUCCESS:
      return {
        ...state,
        locationDistrictResponseData: parseData(
          action.payload.locationsStrNotAuth || action.payload.data.locationsStr
        ),
        fetchingDistrictLocation: false,
        fetchedDistrictLocation: true,
        errorDistrictLocation: null,
      };
    case REFRESH_TOKEN_DATA_SUCCESS:
      return {
        ...state,
        loginResponseData: action?.payload?.tokenAuth?.refreshExpiresIn,
        fetchingLogin: false,
        fetchedLogin: true,
        errorLogin: null,
      };
    case FORGOT_DATA_SUCCESS:
      return {
        ...state,
        forgotResponseData: action?.payload,
        fetchingForgot: false,
        fetchedForgot: true,
        errorForgot: null,
      };
    case RESET_DATA_SUCCESS:
      return {
        ...state,
        resetResponseData: action?.payload,
        fetchingReset: false,
        fetchedReset: true,
        errorReset: null,
      };
    case CURRENTUSER_DATA_SUCCESS:
      return {
        ...state,
        currentUserResponseData: action?.payload,
        fetchingcurrentUser: false,
        fetchedcurrentUser: true,
        errorcurrentUser: null,
      };
    case FETCH_CONTRIBUTION_PLAN_SUCCESS:
      return {
        ...state,
        contributionPlanResponseData: parseData(
          action.payload.contributionPlanBundle
        ),
        fetchingcontributionPlan: false,
        fetchedcontributionPlan: true,
        errorcontributionPlan: null,
      };
    case FETCH_CONTRIBUTIONBYID_PLAN_SUCCESS:
      return {
        ...state,
        contributionPlanByIdResponseData: parseData(
          action.payload.policyHolderContributionPlanBundle
        ),
        fetchingcontributionPlanById: false,
        fetchedcontributionPlanById: true,
        errorcontributionPlanById: null,
      };
    case FETCH_INSUREEBYID_SUCCESS:
      return {
        ...state,
        insureeByIdResponseData: parseData(action.payload.insurees),
        fetchinginsureeById: false,
        fetchedinsureeById: true,
        errorinsureeById: null,
      };
    case CLEAN_SELECTED_INSUREE:
      return {
        ...state,
        insureeByIdResponseData: null,
      };
    case FETCH_POLICYHOLDERINSUREE_SUCCESS:
      return {
        ...state,
        policyHolderByInsureeResponseData: parseData(
          action.payload.policyHolderInsuree
        ),
        policyHolderByInsureeResponseDataPageInfo: pageInfo(
          action?.payload?.policyHolderInsuree
        ),

        fetchingpolicyHolderByInsuree: false,
        fetchedpolicyHolderByInsuree: true,
        errorpolicyHolderByInsuree: null,
      };
    case FETCH_POLICYHOLDER_USER_SUCCESS:
      return {
        ...state,
        policyholderUserResponseData: parseData(
          action.payload.policyHolderUser
        ),
        fetchingPolicyholderUser: false,
        fetchedPolicyholderUser: true,
        errorPolicyholderUser: null,
      };
    case FETCH_MUNICIPALITY_LOCATION_SUCCESS:
      return {
        ...state,
        locationMunicipalityResponseData: parseData(
          action.payload.locationsStrNotAuth || action.payload.data.locationsStr
        ),
        fetchingMunicipalityLocation: false,
        fetchedMunicipalityLocation: true,
        errorMunicipalityLocation: null,
      };
    case FETCH_ALL_LOCATION_REQUEST:
      return {
        ...state,
        fetchingLocation: true,
        fetchedLocation: false,
        errorLocation: null,
      };
    case FETCH_ALL_LOCATION_SUCCESS:
      const { data, type } = action.payload;
      return {
        ...state,
        locationData: {
          ...state.locationData,
          [type]: parseData(data.locationsStrNotAuth || data.data.locationsStr), // Store data by type
        },
        fetchingLocation: false,
        fetchedLocation: true,
        errorLocation: null,
      };
    case FETCH_VILLAGE_LOCATION_SUCCESS:
      return {
        ...state,
        locationVillageResponseData: parseData(
          action.payload.locationsStrNotAuth || action.payload.data.locationsStr
        ),
        fetchingVillageLocation: false,
        fetchedVillageLocation: true,
        errorVillageLocation: null,
      };
    case CREATE_POLICYHOLDERINSUREECREATE_SUCCESS:
      return {
        ...state,
        createPolicyholderInsureeCreate: action.payload,
        fetchingPolicyholderInsureeCreate: false,
        fetchedPolicyholderInsureeCreate: true,
        errorPolicyholderInsureeCreate: null,
      };
    case UPDATE_POLICYHOLDERINSUREEUPDATE_SUCCESS:
      return {
        ...state,
        updatePolicyholderInsureeUpdate: action.payload,
        fetchingPolicyholderInsureeUpdate: false,
        fetchedPolicyholderInsureeUpdate: true,
        errorPolicyholderInsureeUpdate: null,
      };
    case DELETE_POLICYHOLDERINSUREEDELETE_SUCCESS:
      return {
        ...state,
        deletePolicyholderInsureedelete: action.payload,
        fetchingPolicyholderInsureedelete: false,
        fetchedPolicyholderInsureedelete: true,
        errorPolicyholderInsureedelete: null,
      };
    case PRINT_INSUREE_SUCCESS:
      return {
        ...state,
        printInsuree: action?.payload?.sentNotification?.data,
        fetchingPrintInsuree: false,
        fetchedPrintInsuree: true,
        errorPrintInsuree: null,
      };
    case CLEAR_PRINT_INSUREE:
      return {
        ...state,
        printInsuree: null,
      };
    case FETCH_PAYEMTS_SUCCESS:
      return {
        ...state,
        paymentData: parseData(action?.payload?.payments),
        paymentDataPageInfo: pageInfo(action?.payload?.payments),
        fetchingpaymentData: false,
        fetchedpaymentData: true,
        errorpaymentData: null,
      };
    case FETCH_PAYEMTSBYID_SUCCESS:
      return {
        ...state,
        paymentDataById: parseData(action?.payload?.payments),
        fetchingpaymentDataById: false,
        fetchedpaymentDataById: true,
        errorpaymentDataById: null,
      };
    case CORE_MUTATION_RESP:
      const mutations = parseData(action.payload.mutationLogs);
      return {
        ...state,
        fetchingMutations: false,
        mutations: _.unionBy(mutations, state.mutations, "clientMutationId"),
      };
    case DOCUMENT_FILE_RESP:
      return {
        ...state,
        fileData: action.payload.files,
      };
    case DOCUMENT_DOCUMENTS_RESP:
      return {
        ...state,
        documentData: action.payload,
      };
    case TEMPLATE_FILE_RESP:
      return {
        ...state,
        templateData: action.payload?.documentTemplate,
      };

    case UPLOAD_FILE_RESP:
      return {
        ...state,
        uploadedData: action.payload,
      };
    case DELETE_FILE_RESP:
      return {
        ...state,
        deletedData: action.payload.status,
      };
    case FETCH_CONTRACT_REQUEST:
      return {
        ...state,
        fetchingContracts: true,
        fetchedContracts: false,
        contracts: [],
        contractsPageInfo: {},
        contractsTotalCount: 0,
        errorContracts: null,
      };
    case FETCH_CONTRACT_SUCCESS:
      return {
        ...state,
        fetchingContracts: false,
        fetchedContracts: true,
        contracts: parseData(action.payload.contract),
        contractsPageInfo: pageInfo(action.payload.contract),
        contractsTotalCount: !!action.payload.contract
          ? action.payload.contract.totalCount
          : null,
        errorContracts: formatGraphQLError(action.payload),
      };
    case FETCH_CONTRACT_FAILURE:
      return {
        ...state,
        fetchingContracts: false,
        errorContracts: formatServerError(action.payload),
      };
    case FETCH_ENDATE_REQUEST:
      return {
        ...state,
        fetchingDate: true,
        fetchedDate: false,
        endDate: null,
        errorDate: null,
      };
    case FETCH_ENDATE_SUCCESS:
      return {
        ...state,
        fetchingDate: false,
        fetchedDate: true,
        endDate: !!action.payload.validateEnddateByPeriodicity
          ? JSON.parse(
              action.payload.validateEnddateByPeriodicity.replace(/'/g, '"')
            )
          : null,
        errorDate: formatGraphQLError(action.payload),
      };
    case FETCH_ENDATE_FAILURE:
      return {
        ...state,
        fetchingDate: false,
        errorDate: formatServerError(action.payload),
      };
    // case "CONTRACT_FROMDATE_CLEAR":
    //   return {
    //     ...state,
    //     fetchingDate: false,
    //     fetchedDate: false,
    //     endDate: {},
    //     errorDate: null,
    //   };
    case FETCH_CREATE_CONTRACT_SUCCESS:
      return {
        ...state,
        contractResponseData: action.payload,
        fetchingContract: false,
        fetchedContract: true,
        errorContract: null,
      };
    case FETCH_CONTRACT_DETAILS_REQUEST:
      return {
        ...state,
        fetchingContractDetails: true,
        fetchedContractDetails: false,
        contractDetails: [],
        contractDetailsPageInfo: {},
        contractDetailsTotalCount: 0,
        errorContractDetails: null,
      };
    case FETCH_CONTRACT_DETAILS_SUCCESS:
      return {
        ...state,
        fetchingContractDetails: false,
        fetchedContractDetails: true,
        contractDetails: parseData(action.payload.contractDetails),
        contractDetailsPageInfo: pageInfo(action.payload.contractDetails),
        contractDetailsTotalCount: !!action.payload.contractDetails
          ? action.payload.contractDetails.totalCount
          : null,
        errorContractDetails: formatGraphQLError(action.payload),
      };
    case FETCH_CONTRACT_DETAILS_FAILURE:
      return {
        ...state,
        fetchingContractDetails: false,
        errorContractDetails: formatServerError(action.payload),
      };
    case FETCH_POLICYHOLDER_INSUREE_REQUEST:
      return {
        ...state,
        fetchingPickerPolicyHolderInsurees: true,
        fetchedPickerPolicyHolderInsurees: false,
        pickerPolicyHolderInsurees: [],
        pickerPolicyHolderInsureesPageInfo: {},
        pickerPolicyHolderInsureesTotalCount: 0,
        errorPickerPolicyHolderInsurees: null,
      };
    case FETCH_POLICYHOLDER_INSUREE_SUCCESS:
      return {
        ...state,
        fetchingPickerPolicyHolderInsurees: false,
        fetchedPickerPolicyHolderInsurees: true,
        pickerPolicyHolderInsurees: parseData(
          action.payload.policyHolderInsuree
        ),
        pickerPolicyHolderInsureesPageInfo: pageInfo(
          action.payload.policyHolderInsuree
        ),
        pickerPolicyHolderInsureesTotalCount: !!action.payload
          .policyHolderInsuree
          ? action.payload.policyHolderInsuree.totalCount
          : null,
        errorPickerPolicyHolderInsurees: formatGraphQLError(action.payload),
      };
    case UPDATE_PAYMENT_SUCCESS:
      return {
        ...state,
        updatePayment: action.payload,
        fetchingUpdatePayment: false,
        fetchedUpdatePayment: true,
        errorUpdatePayment: null,
      };
    case SUBMIT_CONTRACT_SUCCESS:
      return {
        ...state,
        submitContract: action.payload,
        fetchingSubmitContract: false,
        fetchedSubmitContract: true,
        errorSubmitContract: null,
      };
    case DELETE_CONTRACT_DETAIL_SUCCESS:
      return {
        ...state,
        deleteContractDetail: action.payload,
        fetchingdeleteContractDetail: false,
        fetcheddeleteContractDetail: true,
        errordeleteContractDetail: null,
      };
    case FETCH_POLICYHOLDER_INSUREE_FAILURE:
      return {
        ...state,
        fetchingPickerPolicyHolderInsurees: false,
        errorPickerPolicyHolderInsurees: formatServerError(action.payload),
      };
    case FETCH_USER_VALIDATION_SUCCESS:
      return {
        ...state,
        userValidationDetail: action.payload,
        fetchingUserValidationDetail: false,
        fetchedUserValidationDetail: true,
        errorUserValidationDetail: null,
      };
    case PRINT_POLICYHOLDER_SUCCESS:
      return {
        ...state,
        printPolicyholder: action?.payload?.sentNotification?.data,
        fetchingPrintPolicyholder: false,
        fetchedPrintPolicyholder: true,
        errorPrintPolicyholder: null,
      };
    case FETCH_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        fetchingNotificationList: true,
        fetchedNotificationList: false,
        notificationList: null,
        notificationListTotalCount: null,
        errorNotificationList: null,
      };
    case FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        fetchingNotificationList: false,
        fetchedNotificationList: true,
        notificationList:
          !!action.payload && parseData(action.payload.camuNotifications),
        notificationListTotalCount:
          !!action.payload && !!action.payload.camuNotifications
            ? action.payload.camuNotifications.totalCount
            : null,
        errorNotificationList: formatGraphQLError(action.payload),
      };
    case FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        fetchingNotificationList: false,
        errorNotificationList: formatServerError(action.payload),
      };
    default:
      return state;
  }
};

export default profileReducer;
